// @givmo/employer-module — the neutral lock mark: what stands in an avatar's circle for something the
// company may not see the picture of (a Private, withheld or hidden charity collection, EP-WEB40). A
// Private collection's cover is its owner's own picture, so it is never drawn, and initials of the
// words that stand for it would read as someone's. Decorative, like the initials it replaces: the words
// beside it say what it is.

import { Icon, testIdProp } from '@givmo/design-system';
import { Lock } from 'lucide-react';

const SIZE = { sm: 'size-32', lg: 'size-44' } as const;

export function LockMark({ size, testId }: { size: 'sm' | 'lg'; testId?: string }) {
  return (
    <span
      aria-hidden
      className={`inline-flex ${SIZE[size]} shrink-0 items-center justify-center rounded-full bg-neutral-100 text-icon`}
      {...(testId !== undefined ? testIdProp(testId) : {})}
    >
      <Icon icon={Lock} size={size === 'lg' ? 18 : 14} aria-hidden />
    </span>
  );
}
